/**
 * Registru orașe principale din România — coordonate WGS84.
 * Folosit pentru sampling din cuburile Zarr la pozițiile orașelor.
 */

export const CITIES = [
  { id: 'bucuresti',    name: 'București',      lat: 44.4268, lon: 26.1025, pop: 1_800_000 },
  { id: 'cluj',         name: 'Cluj-Napoca',    lat: 46.7712, lon: 23.6236, pop: 324_000 },
  { id: 'timisoara',    name: 'Timișoara',      lat: 45.7489, lon: 21.2087, pop: 319_000 },
  { id: 'iasi',         name: 'Iași',           lat: 47.1585, lon: 27.6014, pop: 290_000 },
  { id: 'constanta',    name: 'Constanța',      lat: 44.1598, lon: 28.6348, pop: 283_000 },
  { id: 'craiova',      name: 'Craiova',        lat: 44.3302, lon: 23.7949, pop: 269_000 },
  { id: 'brasov',       name: 'Brașov',         lat: 45.6427, lon: 25.5887, pop: 253_000 },
  { id: 'galati',       name: 'Galați',         lat: 45.4353, lon: 28.0080, pop: 249_000 },
  { id: 'ploiesti',     name: 'Ploiești',       lat: 44.9462, lon: 26.0231, pop: 209_000 },
  { id: 'oradea',       name: 'Oradea',         lat: 47.0458, lon: 21.9189, pop: 196_000 },
  { id: 'sibiu',        name: 'Sibiu',          lat: 45.7928, lon: 24.1522, pop: 147_000 },
  { id: 'arad',         name: 'Arad',           lat: 46.1754, lon: 21.3123, pop: 145_000 },
  { id: 'targu_mures',  name: 'Târgu Mureș',    lat: 46.5455, lon: 24.5625, pop: 134_000 },
  { id: 'bacau',        name: 'Bacău',          lat: 46.5670, lon: 26.9146, pop: 144_000 },
  { id: 'suceava',      name: 'Suceava',        lat: 47.6635, lon: 26.2732, pop: 92_000 },
];

/**
 * Adaugă un oraș custom (din căutare) în lista de monitorizare.
 * Dacă există deja, nu adaugă duplicat.
 * @returns {object} Orașul adăugat/existent
 */
export function addCustomCity(name, lat, lon) {
  const id = name.toLowerCase().replace(/[^a-z0-9]/g, '_');

  // Verifică dacă există deja
  const existing = CITIES.find(c => c.id === id);
  if (existing) return existing;

  const city = { id, name, lat, lon, pop: 0, custom: true };
  CITIES.push(city);
  return city;
}

/**
 * Haversine — distanță în km între două puncte.
 */
function haversine(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * Găsește orașul cel mai aproape de coordonatele date.
 */
export function findNearestCity(lat, lon) {
  let best = CITIES[0];
  let bestDist = Infinity;
  for (const city of CITIES) {
    const d = haversine(lat, lon, city.lat, city.lon);
    if (d < bestDist) {
      bestDist = d;
      best = city;
    }
  }
  return best;
}

/**
 * Returnează orașul implicit — geolocation dacă disponibil, altfel București.
 * @returns {Promise<object>} Orașul implicit
 */
export function getDefaultCity() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve(CITIES[0]); // București
      return;
    }

    // Timeout scurt — 3s, nu vrem să blocăm interfața
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const nearest = findNearestCity(pos.coords.latitude, pos.coords.longitude);
        resolve(nearest);
      },
      () => {
        resolve(CITIES[0]); // fallback București
      },
      { timeout: 3000, maximumAge: 300_000 }
    );
  });
}
